import { InventoryMetersApiClient } from '../services/api/inventoryMeters';

let client: InventoryMetersApiClient;

const inventoryMetersFactory = () => (client = new InventoryMetersApiClient(undefined));

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getInventoryMetersApi = (): InventoryMetersApiClient => client ?? inventoryMetersFactory();
